import { Nav } from 'react-bootstrap'
import { NavItemWrapper, NavWrapper } from '../styles'

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean
}

const CompareNav = (props: IProps) => {
    const tabWidth = 200;

    const hrefPrefix = props.isAdmin ? '/admin/reports/dash-board' : `/center/${props.centerId}/reports/dash-board`;
    const outsideHrefPrefix = props.isAdmin ? __OUTSIDEURL__ + '/admin/dashboard' : __OUTSIDEURL__ + '/centers/dashboard';

    return (
        <NavWrapper>
            <div style={{ backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='ms-pills'>
                    <NavItemWrapper active={props.activeKey == 'CONVERSION'} href={`${hrefPrefix}/compare-conversion`} tabWidth={tabWidth}>
                        Conversion
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'VOLUME'} href={`${hrefPrefix}/compare-volume`} tabWidth={tabWidth}>
                        Volume
                    </NavItemWrapper>
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default CompareNav;